import { SEO, breadcrumbSchema } from '../components/SEO';
import { STATIC_SEO } from '../data/seoConfig';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import { ProjectCard } from '../components/cards';
import { Reveal, Stagger, StaggerItem } from '../components/Reveal';
import { PROJECTS } from '../data/projects';
import { IMAGES } from '../data/site';

const ProjectsPage = () => (
  <>
    <SEO
      title={STATIC_SEO.projects.title}
      description={STATIC_SEO.projects.description}
      path="/projects/"
      jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Projects', path: '/projects/' }])]}
    />
    <PageHero
      overline="Our Work"
      title="Spaces we're proud to put our name on"
      intro="A look at the kind of outdoor living environments we design and build — from intimate fireside patios to complete backyard transformations."
      image={IMAGES.hero}
      breadcrumbs={[{ name: 'Home', path: '/' }, { name: 'Projects' }]}
    />
    <section className="py-20 md:py-28">
      <div className="container-site">
        <Stagger className="grid gap-x-6 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
          {PROJECTS.map((p) => <StaggerItem key={p.slug}><ProjectCard project={p} /></StaggerItem>)}
        </Stagger>
        <Reveal className="mt-16 border border-dashed border-bronze/50 bg-paper2/50 px-8 py-8 text-center" data-testid="projects-placeholder-note">
          <p className="text-sm text-muted2">
            We're currently curating our full project gallery with client-approved photography. These showcases represent the kind of work we design and build — ask to see recent local projects during your free consultation.
          </p>
        </Reveal>
      </div>
    </section>
    <CTASection title="Your project could be next" text="Every space we build starts with a conversation at your home. Free consultations across the Omaha & Lincoln metro." testId="projects-cta" />
  </>
);

export default ProjectsPage;
